/**
 * Sorting utilities for domain objects with date fields.
 */
/**
 * Sort items with `date` and `createdAt` fields in descending order (newest first).
 * Tie-breaks on `createdAt` when dates match.
 */
export function sortByDateDesc(items) {
    return [...items].sort((a, b) => {
        if (a.date === b.date)
            return a.createdAt < b.createdAt ? 1 : -1;
        return a.date < b.date ? 1 : -1;
    });
}
/**
 * Sort items with `dateAdded` field in descending order (newest first).
 */
export function sortByDateAddedDesc(items) {
    return [...items].sort((a, b) => (a.dateAdded < b.dateAdded ? 1 : -1));
}
